#import "../fragments/lead-attachments-fragment.graphql"

query GetAttachmentsForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...LeadAttachmentsFragment
    }
}
